/**
 * Point Excalidraw at the app's own copy of its fonts (Requirement 7.4).
 *
 * Excalidraw builds its font registry the first time anything needs fonts —
 * rendering the editor, or `exportToSvg` inlining fonts for a new diagram or an
 * import on the browser page — and caches it for the session. If
 * `window.EXCALIDRAW_ASSET_PATH` is unset at that moment, the registry falls
 * back to a public CDN for the rest of the session. So every module that loads
 * `@excalidraw/excalidraw` imports this one first, for its side effect.
 *
 * The fonts are copied into `public/excalidraw-assets/` by
 * `scripts/copy-excalidraw-assets.mjs` before `dev` and `build`.
 */

/** The URL prefix the copied Excalidraw assets are served from. */
export const EXCALIDRAW_ASSET_PATH: string = "/excalidraw-assets/"

// `window` is typed loosely for this one assignment: the property is an
// Excalidraw runtime convention with no ambient type in the package.
;(window as unknown as { EXCALIDRAW_ASSET_PATH: string }).EXCALIDRAW_ASSET_PATH =
  EXCALIDRAW_ASSET_PATH
